module.exports = __webpack_public_path__ + "static/media/client-landing-3.ed717d4e.jpg";